import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { ACCOUNT_DELETION_ROUTES } from "../../../constants/accountDeletionRoutes";
import "./public-layout.scss";

const AccountDeletionPublicLayout = ({
    title,
    description,
    children,
    showRecoveryLink = false,
    showRestrictedLink = false,
}) => {
    const { t } = useTranslation();
    return (
        <main className="account-deletion-public-page">
            <section className="account-deletion-public-card" aria-labelledby="account-deletion-public-title">
                <p className="account-deletion-public-card__eyebrow">MUZONE</p>
                <h1 id="account-deletion-public-title">{title}</h1>
                {description && <p className="account-deletion-public-card__lead">{description}</p>}
                {children}
                <nav className="account-deletion-public-card__links" aria-label={t("accountDeletionPublic.navigationLabel")}>
                    {showRecoveryLink && (
                        <a href={ACCOUNT_DELETION_ROUTES.recovery}>
                            {t("accountDeletionPublic.actions.recovery")}
                        </a>
                    )}
                    {showRestrictedLink && (
                        <a href={ACCOUNT_DELETION_ROUTES.restricted}>
                            {t("accountDeletionPublic.actions.restricted")}
                        </a>
                    )}
                    <a href="/privacy">{t("accountDeletionPublic.actions.privacy")}</a>
                </nav>
            </section>
        </main>
    );
};

AccountDeletionPublicLayout.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    children: PropTypes.node,
    showRecoveryLink: PropTypes.bool,
    showRestrictedLink: PropTypes.bool,
};

export default AccountDeletionPublicLayout;
